<template>
  <div class="pay-order-content">
    <rt-card :title="''">
      <div class="pay-order-main">
        <div class="pay-amount-item plate" :style="{fontSize: bulletPlateSizeOptions[bulletPlateSize], color: bulletPlateColorOptions[bulletPlateColor]}">
          {{ activeData.plateNumber }}
          <el-tag :type="titleObj.type" v-if="titleObj.value">{{titleObj.value}}</el-tag>
        </div>
        <ul>
          <li v-if="activeData.passTime">识别时间: {{activeData.passTime}}</li>
          <li>
            <div v-html="activeData.msg"></div>
          </li>
          <li v-if="activeData.messageType === '30'">
            <el-input
              type="textarea"
              placeholder="请输入备注"
              v-model="updateRemark"
              maxlength="200"
              show-word-limit
            ></el-input>
          </li>
        </ul>
        <div class="pay-btn-item">
          <el-button class="btn-mini" type="primary" style="padding: 12px 50px;" @click="handleClick(1)" v-if="activeData.isShowConfirmButton">{{activeData.confirmButtonText}}</el-button>
        </div>
        <div class="pay-btn-item">
          <el-button @click="handleClick(0)" v-if="activeData.isShowCancelButton">{{activeData.cancelButtonText}}</el-button>
        </div>
        <ul v-if="activeData.messageType === '30'">
          <li class="li-flex li-img">
            <el-image
              :src="activeData.FullImage"
              fit="contain"
              :preview-src-list="[activeData.FullImage]"
            >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
              <div slot="error" class="image-slot">暂无图片</div>
            </el-image>
          </li>
        </ul>
      </div>
    </rt-card>
  </div>
</template>

<script>
import rtCard from "@/serviceComponents/rtCard.vue";
import { blackParkInPubSub } from "@/service/pubsub/index";
import ParkLotMix from "@/minxs/parkLotId";
import { openSurePassIn, openForbidPassIn } from "@/api/module/park";

export default {
  props: {
    bulletPlateSize: {
      type: Number,
      default: 0,
    },
    bulletPlateColor: {
      type: Number,
      default: 0,
    },
    showPassIn: {
      type: Number,
      default: 0,
    }
  },
  components: {
    rtCard,
  },
  mixins: [ParkLotMix],
  data() {
    return {
      blackMsgArr: [],
      blackMsg: undefined,
      activeData: {
        messageType: null,
        park_lot_gate_id: null,
        msg: '--',
        confirmButtonText: null,
        isShowConfirmButton: null,
        cancelButtonText: null,
        isShowCancelButton: null,
        passTime: '--',
        plateNumber: '--',
        FullImage: null,
        carTypeStr: null,
      },
      titleObj: {
        value: '暂无记录'
      },
      updateRemark: undefined,
    }
  },
  computed: {
    gateIds: function () {
      return JSON.parse(this.$store.state.order.inGateIdTabs);
    },
    tabsGateId: function() {
      return this.$store.state.order.tabsGateId;
    },
    moreBlackParkIn: function () {
      return this.$store.state.order.moreBlackParkIn;
    },
  },
  watch: {
    $route: {
      handler: function(){
        this.blackMsgArr = [];
        this.reSetData();
      },
      deep: true
    },
  },
  mounted() {
    // console.log(this.bulletPlateSize)
    this.$nextTick(() => {
      blackParkInPubSub.unsubscribe();
      blackParkInPubSub.subscribe(this.getBlackMsg);
      // console.log(this.gateIds)
      document.onkeyup = e => {
        if (e.keyCode == 89) {
          this.handleClick(1)
        } else if (e.keyCode == 78) {
          this.handleClick(0)
        }
      };
    })
  },
  methods:{
    reSetData() {
      this.activeData = {
        messageType: null,
        park_lot_gate_id: null,
        msg: '--',
        confirmButtonText: null,
        isShowConfirmButton: null,
        cancelButtonText: null,
        isShowCancelButton: null,
        passTime: '--',
        plateNumber: '--',
        FullImage: null,
        carTypeStr: null,
      }
    },
    getBlackMsg(data) {
      console.log('getBlackMsg', data);
      if (!data) {
        this.blackMsgArr = [];
        this.reSetData();
        return false;
      }
      this.updateRemark = undefined;
      let obj = {
        park_lot_gate_id: data.park_lot_gate_id,
        sentryId: data.SentryId,
        messageType: data.message_type,
        hasClickButton: null,
        plateNumber: data.plate_number,
      };
      if (data.message_type === '1' && data.ForeignFrom || data.message_type === '20' || data.message_type === '31'){
        obj.msg = `<p>备注：${data.message_type === '1' && data.ForeignFrom ? data.ForeignFrom : data.cmd_msg ? data.cmd_msg : data.ForbidLed}</p>`;
        obj.confirmButtonText = '确定';
        obj.isShowConfirmButton = true;
        obj.cancelButtonText = '';
        obj.isShowCancelButton = false;
      } else if (data.message_type === '30') {
        obj.msg = `
          <p style="font-size: 18px;" >提示：${data.cmd_msg}</p>
          `;
        obj.parkPassingsId = data.park_passings_id;
        obj.confirmButtonText = '确认入场(Y)';
        obj.isShowConfirmButton = true;
        obj.cancelButtonText = '禁止入场(N)';
        obj.isShowCancelButton = true;
        obj.carTypeStr = data.CarType;
        obj.FullImage = data.FullImage;
        obj.passTime = data.pass_time;
      } else if (data.message_type === '5') {
        obj.msg = `<p>备注：${ data.cmd_msg}</p>`;
        obj.confirmButtonText = '确定';
        obj.isShowConfirmButton = false;
        obj.cancelButtonText = '';
        obj.isShowCancelButton = false;
      } else if (data.message_type === '32') {
        obj.msg = `<p>备注：${ data.plate_number}禁止入场</p>`;
        obj.confirmButtonText = '确定';
        obj.isShowConfirmButton = false;
        obj.cancelButtonText = '';
        obj.isShowCancelButton = false;
      }
      // console.log(obj)
      let arrSamePlate = this.blackMsgArr.filter(v => {return v.plateNumber === obj.plateNumber});
      let arrGateId = this.blackMsgArr.filter(v => {return v.park_lot_gate_id === obj.park_lot_gate_id});
      // console.log(arrSamePlate, arrGateId)
      if (arrSamePlate.length === 0 && arrGateId.length === 0) {
        if (obj.messageType !== '5' || obj.messageType === '5' && this.activeData.messageType === '30' || obj.messageType === '32' && this.activeData.messageType === '30') {
          this.blackMsgArr.push(obj);
        }
      } else if (arrGateId.length > 0 && arrSamePlate.length === 0) {
        this.blackMsgArr[this.blackMsgArr.indexOf(arrGateId[0])] = obj;
      } else if (arrSamePlate.length > 0) {
        this.blackMsgArr[this.blackMsgArr.indexOf(arrSamePlate[0])] = obj;
      }
      let activeGateId = this.blackMsgArr.filter(v => {return v.park_lot_gate_id === String(this.tabsGateId)});
      if (!this.activeData.messageType ||
        this.activeData.messageType === '30' && (activeGateId.length > 0 && activeGateId[0].messageType === '5' || activeGateId.length > 0 && activeGateId[0].messageType === '32') ||
        activeGateId.length > 0 && activeGateId[0].messageType !== '5') {
        this.activeData = activeGateId[0];
      }
      console.log(this.blackMsgArr, this.activeData, activeGateId, this.tabsGateId)
      let typeIndex = Math.ceil(Math.random()*5);
      if (this.activeData.messageType === '30') {
        this.titleObj = {value: this.activeData.carTypeStr, type: this.titleType[typeIndex-1]};
      } else {
        this.titleObj = {value: undefined, type: this.titleType[typeIndex-1]};
      }
    },
    handleClick(n) {
      // console.log(n, this.activeData)
      this.activeData.isShowConfirmButton = false;
      this.activeData.isShowCancelButton = false;
      this.activeData.hasClickButton = n;
      this.resetDotTabs();
      this.resetBlackMsgArr(this.activeData);
      if (this.activeData.messageType === '30' && this.activeData.hasClickButton === 1) {
        this.openSurePassIn();
      } else if (this.activeData.messageType === '30' && this.activeData.hasClickButton === 0) {
        this.openForbidPassIn();
      }
    },
    resetDotTabs() {
      this.gateIds.forEach(v => {
        if (v.Id === parseInt(this.activeData.park_lot_gate_id)) {
          v.hidden = true
        }
      });
      this.$store.dispatch("SetInGateIdTabs", JSON.stringify(this.gateIds));
    },
    resetBlackMsgArr(data) {
      let arr = this.blackMsgArr.filter(v => {return data.hasClickButton !== null && data.plateNumber === v.plateNumber});
      let sameSentryBox = this.blackMsgArr.filter(v => {return v.sentryId === sessionStorage.getItem('sentryId')});
      // console.log('parkInNoticeClick', arr, sameSentryBox, this.blackMsgArr)
      if (arr.length === sameSentryBox.length) {
        this.blackMsgArr = [];
        this.$store.dispatch('SetBlackMsgArrStr', JSON.stringify(this.blackMsgArr));
        this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'clear'});
      } else {
        let index = this.blackMsgArr.indexOf(arr[0]);
        this.blackMsgArr.splice(index, 1);
        this.$store.dispatch('SetBlackMsgArrStr', JSON.stringify(this.blackMsgArr));
        this.moreBlackParkIn[parseInt(sessionStorage.getItem('sentryId'))].forEach(v => {
          if (v.plate_number === data.plateNumber) {
            this.$store.dispatch("SETMoreBlackParkIn", {obj: v, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'update'});
          }
        })
      }
      // console.log('parkInNoticeClick', arr, sameSentryBox, this.blackMsgArr)
    },
    openSurePassIn() {
      openSurePassIn({ParkPassingsId: this.activeData.parkPassingsId, remark: this.updateRemark}).then(() => {
      })
    },
    openForbidPassIn() {
      openForbidPassIn({ParkPassingsId: this.activeData.parkPassingsId, remark: this.updateRemark}).then(() => {
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .rt-card{
    min-height: 400px;
  }
  .pay-order-main ul .li-img .el-image{
    flex: 1;
  }
  .pay-order-main ul .li-flex div{
    width: 100%;
  }
</style>
